import type { ResourcesConfig } from 'aws-amplify';

export const COOKIE_DOMAIN =
  process.env.NEXT_PUBLIC_AUTH_COOKIE_DOMAIN ?? '.meinschiff.com';
export const COOKIE_EXPIRES_IN_DAYS = 30;
export const COOKIE_SAMESITE: 'lax' | 'strict' | 'none' = 'lax';
export const COOKIE_SECURE =
  process.env.NEXT_PUBLIC_AUTH_COOKIE_SECURE !== 'false';
export const COOKIE_PATH = '/';

export const SIGN_IN_WITH_BOOKING_NUMBER_TOKEN_COOKIE_NAME = 'bcAuthToken';

export const AUTH_USER_POOL_ID =
  process.env.NEXT_PUBLIC_AUTH_USER_POOL_ID ?? 'eu-central-1_VzQv4GfbT';

export const AUTH_USER_POOL_CLIENT_ID =
  process.env.NEXT_PUBLIC_AUTH_USER_POOL_WEB_CLIENT_ID ??
  '2mpern4jqqmn74s85mlvt0qjh9';

const authConfig: ResourcesConfig['Auth'] = {
  Cognito: {
    // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
    // identityPoolId:
    //   process.env.NEXT_PUBLIC_AUTH_IDENTITY_POOL_ID ??
    //   'eu-central-1:bfa4e349-2561-485b-87e9-3dfaf13bcec7',
    // REQUIRED - Amazon Cognito Region
    // region: process.env.NEXT_PUBLIC_AUTH_REGION ?? 'eu-central-1',
    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: AUTH_USER_POOL_ID,
    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolClientId: AUTH_USER_POOL_CLIENT_ID,
    // loginWith: {
    //   email: true,
    // },
    // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
    // mandatorySignIn: false,
    // OPTIONAL - Configuration for cookie storage
    //
    // ssr: true,
    // // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
    // //authenticationFlowType: 'USER_PASSWORD_AUTH',
    //
    // clientMetadata: {
    //   link: HOST_APP_ACCOUNT,
    // },
  },
};

export const amplifyResourcesConfig: ResourcesConfig = {
  Auth: authConfig,
};
